import { BGrainOverlay, BStripes } from '../layout';
import './BLoadingScreen.css';

type Phase = 'starting' | 'context' | 'searching' | 'deep_research' | 'report' | 'complete' | 'cached' | 'healing';

interface BLoadingScreenProps {
  query: string;
  status: string;
  phase: Phase;
}

const PHASE_PROGRESS: Record<Phase, number> = {
  starting: 10,
  context: 25,
  searching: 45,
  deep_research: 65,
  report: 85,
  complete: 100,
  cached: 100,
  healing: 50,
};

const PHASE_NEXT: Record<Phase, string> = {
  starting: 'finding key artists',
  context: 'building context',
  searching: 'discovering connections',
  deep_research: 'generating report',
  report: 'almost ready...',
  complete: 'done!',
  cached: 'done!',
  healing: 'completing...',
};

/**
 * Loading screen with animated query display and progress.
 */
export function BLoadingScreen({ query, status, phase }: BLoadingScreenProps) {
  // Split query into words for animation
  const words = query.split(' ').filter(Boolean);

  return (
    <div className="b-page b-page--dark b-loading-screen">
      <BStripes />
      <BGrainOverlay />

      <div className="b-loading__container">
        <div className="b-loading__query">
          {words.map((word, i) => (
            <span key={i} className="b-loading__line">
              <span
                className="b-loading__word"
                style={{ animationDelay: `${i * 0.15}s` }}
              >
                {word}
              </span>
            </span>
          ))}
        </div>

        <div className="b-loading__progress">
          <div className="b-loading__bar-container">
            <div
              className="b-loading__bar"
              style={{ width: `${PHASE_PROGRESS[phase]}%` }}
            />
          </div>

          <div className="b-loading__status">
            <span className="b-loading__current">
              <span className="b-loading__dot" />
              {status}
            </span>
            <span className="b-loading__next">
              next: {PHASE_NEXT[phase]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
